module.exports = __webpack_public_path__ + "img/new03.39abda7d.jpg";